import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { Group, Form, Field, Columns, Submit, InfoGroup, Info } from '~/form'
import EventLog from '~/event/log'

export default function ContactForm({
  formUpdate,
  formSubmit,
  formState,
  formLoading,
  title = 'Muokkaa yhteyshenkilöä',
  prefix = '',
  actions = false,
  onCancel,
  contact,
}) {
  return (
    <Fragment>
      <div className="datatable-action-panels">
        <div className="datatable-action-panel datatable-action-panel--left">
          <div className="datatable-action-content">
            <Group title={title}>
              <Field
                placeholder="Nimi"
                size="large"
                type="text"
                name={prefix + 'name'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                label="Sähköposti"
                type="email"
                name={prefix + 'email'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                label="Puhelinnumero"
                type="text"
                name={prefix + 'data.phone'}
                onChange={formUpdate}
                formState={formState}
              />
              <Field
                label="Muistiinpanot"
                type="textarea"
                name={prefix + 'data.notes'}
                onChange={formUpdate}
                formState={formState}
              />
              <Columns count="2">
                <Field
                  label="Oletuskieli"
                  type="radios"
                  name={prefix + 'lang'}
                  options={[
                    { value: 'fi', label: 'Suomi' },
                    { value: 'en', label: 'Englanti' },
                    { value: 'se', label: 'Ruotsi' },
                  ]}
                  onChange={formUpdate}
                  formState={formState}
                />
              </Columns>
            </Group>
            <Group title="Ilmoitusasetukset">
              {/*<Field inputLabel="2 viikon raportti"
                type="checkbox"
                name={ prefix + "data.notifications.biweeklyReport" }
                onChange={ formUpdate }
                formState={ formState } />
              <Field inputLabel="Uusi vastaus kyselyyn"
                type="checkbox"
                name={ prefix + "data.notifications.newAnswer" }
                onChange={ formUpdate }
                formState={ formState } />*/}
              <Field
                inputLabel="Peru ilmoitukset"
                type="checkbox"
                name={prefix + 'data.notifications.blockAll'}
                onChange={formUpdate}
                formState={formState}
              />
            </Group>
            <Group title="Linkit">
              <Field type="links" name={prefix + 'links'} multiple onChange={formUpdate} formState={formState} />
            </Group>
          </div>
        </div>
        {Map.isMap(contact) ? (
          <div className="datatable-action-panel datatable-action-panel--right datatable-action-panel--wide">
            <div>
              <EventLog
                id={contact.get('id')}
                filters={{ contact_id: contact.get('id') }}
                notes
                noteRelations={{ contact_id: contact.get('id') }}
              />
            </div>
          </div>
        ) : null}
      </div>
      {actions ? (
        <div className="datatable-action-buttons datatable-action-buttons--flex">
          <div>
            <Submit content="Tallenna" icon="save" color="green" />
            <button className="datatable-action-button-cancel" onClick={e => e.preventDefault() & onCancel()}>
              Sulje
            </button>
          </div>
          <div></div>
        </div>
      ) : null}
    </Fragment>
  )
}

export let ContactFormValidations = {
  name: ['required'],
  email: ['required'],
}
